import { Directive } from '@angular/core';

@Directive({
  selector: '[libEmptyContainer]'
})
export class EmptyContainerDirective {}
